import { render, staticRenderFns } from "./AppealCard.component.vue?vue&type=template&id=f5f901d0&scoped=true"
import script from "./AppealCard.component.vue?vue&type=script&lang=js"
export * from "./AppealCard.component.vue?vue&type=script&lang=js"
import style0 from "./AppealCard.component.vue?vue&type=style&index=0&id=f5f901d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f901d0",
  null
  
)

export default component.exports